import { useEffect, useMemo, useState } from 'react';

declare global {
  interface Window {
    AdMob?: {
      interstitial: { prepareAndShow: () => Promise<void> };
      rewarded: { prepareAndShow: () => Promise<void> };
    };
  }
}

const useIsTestMode = () =>
  useMemo(() => {
    if (typeof window === 'undefined') return true;
    const params = new URLSearchParams(window.location.search);
    return params.get('testAds') === '1';
  }, []);

export const useAds = () => {
  const isTestMode = useIsTestMode();
  const [adsReady, setAdsReady] = useState(false);

  useEffect(() => {
    if (!isTestMode && window.AdMob) {
      setAdsReady(true);
    }
  }, [isTestMode]);

  const showInterstitial = async () => {
    if (Math.random() >= 0.8) return;
    if (isTestMode || !window.AdMob) {
      await new Promise<void>((resolve) => setTimeout(resolve, 5000));
      // eslint-disable-next-line no-console
      console.log('🎭 Fake interstitial shown');
      return;
    }
    await window.AdMob.interstitial.prepareAndShow();
  };

  const showRewarded = async () => {
    if (isTestMode || !window.AdMob) {
      await new Promise<void>((resolve) => setTimeout(resolve, 3000));
      // eslint-disable-next-line no-console
      console.log('🎭 Fake rewarded ad completed');
      return;
    }
    await window.AdMob.rewarded.prepareAndShow();
  };

  return { showInterstitial, showRewarded, adsReady, isTestMode };
};



